import React from "react";

const CloseIcon = props => (
  <svg width={40} height={40} viewBox="0 0 40 40" {...props}>
    <g filter="url(#filter0_d_58_251)">
      <path d="M20 0C11.1613 0 4 7.16129 4 16C4 24.8387 11.1613 32 20 32C28.8387 32 36 24.8387 36 16C36 7.16129 28.8387 0 20 0ZM27.8452 20.2C28.1484 20.5032 28.1484 20.9935 27.8452 21.2968L25.2903 23.8452C24.9871 24.1484 24.4968 24.1484 24.1935 23.8452L20 19.6129L15.8 23.8452C15.4968 24.1484 15.0065 24.1484 14.7032 23.8452L12.1548 21.2903C11.8516 20.9871 11.8516 20.4968 12.1548 20.1935L16.3871 16L12.1548 11.8C11.8516 11.4968 11.8516 11.0065 12.1548 10.7032L14.7097 8.14839C15.0129 7.84516 15.5032 7.84516 15.8065 8.14839L20 12.3871L24.2 8.15484C24.5032 7.85161 24.9935 7.85161 25.2968 8.15484L27.8516 10.7097C28.1548 11.0129 28.1548 11.5032 27.8516 11.8065L23.6129 16L27.8452 20.2Z" fill="white" fillOpacity="0.8"/>
    </g>
    <defs>
      <filter id="filter0_d_58_251" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_58_251"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_58_251" result="shape"/>
      </filter>
    </defs>
  </svg>
);

export default CloseIcon;

